import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { AuthTokens, MeResponse } from '@ah/contracts';

/**
 * Auth store — token is persisted to `localStorage` (Capacitor's Preferences
 * plugin will replace this in Module 12 for iOS Keychain / Android Keystore).
 * The user object is kept in memory only; we refetch `/me` on hydration so
 * a stale copy is never rendered.
 */
export interface AuthState {
  tokens: AuthTokens | null;
  user: MeResponse | null;
  setSession: (payload: { tokens: AuthTokens; user: MeResponse }) => void;
  setUser: (user: MeResponse | null) => void;
  signOut: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      tokens: null,
      user: null,
      setSession: ({ tokens, user }) => set({ tokens, user }),
      setUser: (user) => set({ user }),
      signOut: () => set({ tokens: null, user: null }),
    }),
    {
      name: 'ah.auth',
      // Persist only the token; hydrate `user` from GET /me on load.
      partialize: (state) => ({ tokens: state.tokens }),
    },
  ),
);
